module.exports = __webpack_public_path__ + "img/tv-now-page-header-scaled.a66f3e99.jpg";